import React, {useEffect, useState} from 'react';
import {checkNull, isBoolTrue} from "../utils/ReactUtils";
import {Tooltip} from "@mui/material";

/**
 * @example
 * <ExpView
 *    title={"Expandable View"}
 *    className={''}
 *    headerClassName={''}
 *    titleClassName={'fw-semi-bold m-0 p-0 px-1 '}
 *    wrapperClassName={''}
 *    toggleClassName={''}
 *    contentClassName={''}
 *    headerToggle={true}
 *    asCollapsible={false}
 *    style={{}}
 *    headerStyle={{}}
 *    titleStyle={{ }}
 *    toggleStyle={{ }}
 *    wrapperStyle={{}}
 *    contentStyle={{}}
 *    scrollVariant={"dark"}
 *    headerHeight={"30px"}
 *    expanded={false}
 *    expandOnHover={false}
 *    showExpandToggle={true}
 *    onToggleClick={(collapsed) => {
 *        console.log('ExpView.onToggleClick.collapsed:', collapsed);
 *    }}
 *    collapseHeight ={'auto'}
 *    height={'auto'}
 *    endControls={<div>Control</div>}
 * >
 *  children
 * </ExpView>
 */
const ExpView = ({
                     className = '',
                     headerClassName = '',
                     titleClassName = '',
                     wrapperClassName = '',
                     toggleClassName = '',
                     contentClassName = '',
                     scrolled = true,
                     div = false,
                     headerToggle = false,
                     closeTooltip = false,
                     asCollapsible = false,
                     style = {},
                     headerStyle = {},
                     titleStyle = {},
                     toggleStyle = {},
                     wrapperStyle = {},
                     contentStyle = {},
                     title = "Expandable Layout",
                     scrollVariant = "light",
                     expandDur = "0.2s",
                     collapseDur = "0.35s",
                     headerHeight = "40px",
                     children,
                     expanded = true,
                     expandOnHover = false,
                     showExpandToggle = true,
                     onExpand,
                     onCollapse,
                     onToggleClick,
                     collapseHeight = '0',//auto
                     height = '200px',
                     endControls,
                     ...props
                 }) => {
    useEffect(() => {
        handleToggleView(isBoolTrue(expanded));
    }, [])

    const [isExpanded, setIsExpanded] = useState(false);
    const [enableHover, setEnableHover] = useState(expandOnHover);

    const handleToggleView = (expand = true) => {
        setIsExpanded(!expand);
        if (checkNull(onToggleClick)) onToggleClick(!expand);
        if (isExpanded) {
            if (checkNull(onExpand)) onExpand();
        } else {
            if (checkNull(onCollapse)) onCollapse();
        }
    };

    const contentStyles = {
        height: isExpanded ? collapseHeight : height,
        // overflow: 'hidden',
        overflowX: 'hidden',
        overflowY: isExpanded ? 'auto' : 'hidden',
        padding: isExpanded ? '0rem .6rem' : '.2rem .6rem',
        opacity: isExpanded ? '0' : '1',
        // transform: `scale(${isExpanded ? '.5' : '1'})`,
        transition: `opacity height ${isExpanded ? collapseDur : expandDur} ease`,
        ...contentStyle
    };

    const toggleButtonStyles = {
        // display: asCollapsible ? 'block' : 'none',
        display: 'block',
        cursor: 'pointer',
        ...toggleStyle,
    };


    return (
        <>
            <div className={`exp-view-wrapper p-0 m-0 ${wrapperClassName}`} style={{...wrapperStyle}}>
                <div
                    className={`exp-view  p-0 m-0 overflow-hidden ${className}`}
                    style={{...style}}
                    onMouseEnter={() => {
                        if (isBoolTrue(expandOnHover) && enableHover) {
                            handleToggleView(true)
                        }
                    }}
                    onMouseLeave={() => {
                        if (isBoolTrue(expandOnHover) && enableHover) {
                            handleToggleView(false)
                        }
                        setEnableHover(true);
                    }}
                    {...props}
                >
                    {/*header*/}
                    <div
                        className={`header d-flex flex-nowrap fd-row w-100 m-0 p-0 justify-content-between align-items-center transition 
            overflow-hidden ${isBoolTrue(headerToggle) ? 'cursor-pointer' : ''} ${isExpanded ? 'expanded' : ''} ${headerClassName}`}
                        style={{
                            height: headerHeight,
                            borderBottom: div ? `.3px solid rgba(255,255,255,${!isExpanded ? ".1" : "0"})` : "none",
                            ...headerStyle
                        }}
                        onClick={() => {
                            if (isBoolTrue(headerToggle)) {
                                setEnableHover(false);
                                handleToggleView(isExpanded);
                            }
                        }}
                    >
                        {/*title*/}
                        < p className={`titlex m-0 px-2 py-0 d-flex text-center overflow-hidden ${titleClassName}`}
                            style={{...titleStyle}}>{title}
                            {/* onClick={() => { handleToggleView(!isExpanded) }} */}
                        </p>
                        {/*close button*/}
                        <div className={'flex-nowrap d-flex fd-row  p-0 m-0 align-items-center'}>
                            <Tooltip title={closeTooltip ? isExpanded ? "Expand" : "Collapse" : ""}>
                                <div
                                    className={`mx-1 p-2 circular d-flex jc-center al-center transition-md toggle align-self-end ${toggleClassName} highlight-dark-hover`}
                                    style={{
                                        fontSize: isBoolTrue(asCollapsible) ? "25px" : "16px",
                                        width: '25px',
                                        height: '25px',
                                        ...toggleButtonStyles,
                                        ...toggleStyle,
                                    }}
                                    onClick={() => {
                                        setEnableHover(false);
                                        handleToggleView(isExpanded);
                                    }}>
                                    <span>
                                        <i className={`icon ${!isExpanded ? (asCollapsible ? "bi bi-plus" : "fa fa-angle-up") : (asCollapsible ? "bi bi-dash" : "fa fa-angle-down")}`}/>
                                    </span>
                                </div>
                            </Tooltip>
                            {endControls && endControls}
                        </div>
                    </div>

                    {/*children*/}
                    <div className={`content transition ${contentClassName} ${isExpanded ? 'expanded' : ''} ${scrolled ? `scroller scroll-${scrollVariant}` : ''}`}
                         style={{...contentStyles}}>{children}
                    </div>
                </div>
            </div>
        </>
    );
};


export default ExpView;
